import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { Typography, Box } from '@mui/material';
export var NuggetArticle = function (_a) {
    var variant = _a.variant;
    if (variant.type === 'LARGE') {
        return (_jsxs(_Fragment, { children: [_jsx(Typography, { sx: bottomTextStyle, variant: "body1", onClick: function () { return window.open(variant.articleUrl, '_blank'); }, children: variant.title }), variant.previewImage && (_jsx(Box, { sx: imageContainerStyle, children: _jsx("img", { src: variant.previewImage, alt: variant.title, style: imageStyle }) }))] }));
    }
    return (_jsx(_Fragment, { children: variant.previewImage && (_jsx(Box, { sx: imageContainerStyle, children: _jsx("img", { src: variant.previewImage, alt: variant.title, style: smallImageStyle }) })) }));
};
var bottomTextStyle = {
    fontFamily: 'Sarabun',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    mt: 2,
    textDecoration: 'underline',
    cursor: 'pointer',
    maxWidth: '100%',
    fontStyle: 'italic',
    color: appColors.color.blue1,
};
var imageContainerStyle = {
    borderRadius: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    width: '100%',
    mt: 2,
    objectFit: 'cover',
    aspectRatio: '16 / 9',
};
var imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '16px',
};
var smallImageStyle = {
    borderRadius: '16px',
    width: '100%',
    objectFit: 'contain',
};
